// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoSection_videoContainer__PU7-R","video":"VideoSection_video__jZWAo","close":"VideoSection_close__rPeSl"};